export default {
  background: '#fff',
  borderRadius: '8px',
  fontFamily: {
    sans: "'normal-light', sans-serif",
  },
  fontSize: {
    medium: '14px',
  },
  body: {
    color: '#444',
  },
  grey: {
    lightest: '#f8f8f8',
    lighter: '#ECECEC',
    medium: '#c1c1c1',
  },
  primary100: '#F9EEE7',
  primary200: '#FAE3DA',
  primary300: '#FADACF',
  primary400: '#FBC5B7',
  primary500: '#F5A28C',
  primary600: '#EE7B5D', //"#FA7268",
  primary700: '#B45E49',
  primary800: '#8D4B3B',
  primary900: '#63362C',
  primary1000: '#2E1C1A',
  secondary: {
    lighter: '#BEF0E9',
    light: '#7CE8D8',
    medium: '#58C9B9',
    dark: '#519D9E',
    darker: '#387778',
  },
  muted: {
    bright: '#FFF8EC',
    dull: '#F1F0EE',
  },
};
